import Stack from '@mui/material/Stack';
import { useEffect, useState } from 'react';
import { getVersion } from '@/components/util';
import color from '@/utils/color';

export const NavigationBackground = ({
  isBackgroundVisible,
  tour,
  showcaseLoaded,
}: {
  isBackgroundVisible: boolean;
  tour: any;
  showcaseLoaded: boolean;
}) => {
  const [isHidden, setIsHidden] = useState(false);

  useEffect(() => {
    if (isBackgroundVisible) setIsHidden(false);
  }, [isBackgroundVisible]);

  return isHidden ? null : (
    <Stack
      sx={{
        position: 'relative',
        height: '100vh',
        zIndex: 1000,
        backgroundColor: showcaseLoaded ? 'transparent' : '#F2F4F7', // if the tour is not loaded yet just hide MP loading screen
        backgroundImage: `url('${process.env.NEXT_PUBLIC_CDN}/tours/${tour.id}/images/${
          tour.mainImage
        }${getVersion(tour.updatedAt)}')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        '&::before': {
          content: "''",
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          background: tour.mainImage ? color.hexToRgbA('#F2F4F7', 0.7) : '#EAECF0',
          zIndex: -1,
        },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      className={isBackgroundVisible ? 'wrapper-visible' : 'wrapper-hidden'}
      onAnimationEnd={(event) => {
        if (event.animationName === 'kioskWrapperFadeOut') setIsHidden(true);
      }}
    />
  );
};
